@switch (chunk.componentType) {
  @case ('section') {
    <div class="my-3">
      <app-ai-chat-section [chunk]="chunk"></app-ai-chat-section>
    </div>
  }
  @case ('table') {
    <div class="my-3">
      <app-ai-chat-table [chunk]="chunk"></app-ai-chat-table>
    </div>
  }
  @case ('button') {
    <div class="my-3">
      <app-ai-chat-generative-button [chunk]="chunk"></app-ai-chat-generative-button>
    </div>
  }
  @case ('bar_chart') {
    <div class="my-3">
      <app-ai-chat-bar-chart [chunk]="chunk"></app-ai-chat-bar-chart>
    </div>
  }
  @case ('line_chart') {
    <div class="my-3">
      <app-ai-chat-line-chart [chunk]="chunk"></app-ai-chat-line-chart>
    </div>
  }
  @case ('pie_chart') {
    <div class="my-3">
      <app-ai-chat-pie-chart [chunk]="chunk"></app-ai-chat-pie-chart>
    </div>
  }
  @case ('gauge_chart') {
    <div class="my-3">
      <app-ai-chat-gauge-chart [chunk]="chunk"></app-ai-chat-gauge-chart>
    </div>
  }
  @case ('banner') {
    <div class="my-3">
      <app-ai-chat-banner [chunk]="chunk"></app-ai-chat-banner>
    </div>
  }
  @case ('score') {
    <div class="my-3">
      <app-ai-chat-score [chunk]="chunk"></app-ai-chat-score>
    </div>
  }
}
